export type HoleCount = "EIGHTEEN" | "NINE" | "NONE";

export const getLayoutHoleCountString = (
  code: string,
  holeCount: HoleCount
) => {
  if (Number.isNaN(code)) {
    return {
      EIGHTEEN: "(18)",
      NINE: "(9)",
      NONE: "",
    }[holeCount];
  } else {
    return `(${code})`;
  }
};
